import type { CampaignCardView } from "../../../shared/types/campaign-card.type";
import { StructureFlow } from "./structure/StructureFlow";

type Props = {
	campaign: CampaignCardView;
};

export const StructureSection = ({ campaign }: Props) => {
	return (
		<section>
			<div className='campaign-detail__section-title'>
				Структура кампанії
			</div>
			<StructureFlow campaign={campaign} />
		</section>
	);
};
